module.exports = __webpack_public_path__ + "static/media/cspire_footer2.311a184c.png";